export const DAY_IN_MS = 24 * 60 * 60 * 1000;

export const getPromotionId = (promotion = {}) => promotion?.id || promotion?._id || "";

export const getCampaignKey = (promotion = {}) =>
  `${getPromotionId(promotion)}:${String(promotion?.updatedAt || "").trim()}`;

export const getFrequencyKey = (promotion = {}, actorKey = "") =>
  `${getCampaignKey(promotion)}:${actorKey || "visitor:anonymous"}`;

export const getDismissKey = (promotion = {}) => getPromotionId(promotion);

export const normalizeTimestamps = (value, windowMs = null, now = Date.now()) =>
  (Array.isArray(value) ? value : [])
    .map((entry) => Number(entry))
    .filter((entry) => Number.isFinite(entry) && entry > 0)
    .filter((entry) => (windowMs ? entry >= now - windowMs : true))
    .slice(-100);

export const resolveFrequencyWindowMs = (promotion = {}) => {
  const frequencyCap = promotion?.frequencyCap || {};
  switch (frequencyCap?.mode) {
    case "day":
      return DAY_IN_MS;
    case "user":
      return Math.max(Number(frequencyCap?.windowDays || 30), 1) * DAY_IN_MS;
    default:
      return null;
  }
};

export const getFrequencyStoreType = (promotion = {}) =>
  promotion?.frequencyCap?.mode === "session" ? "session" : "local";

export const isPromotionDismissed = (
  promotion = {},
  dismissedIds = {},
  stores = {},
  now = Date.now(),
) => {
  const promotionId = getPromotionId(promotion);
  if (!promotionId) return true;
  const inViewDismissal = dismissedIds[promotionId];
  if (inViewDismissal === true) return true;
  if (typeof inViewDismissal === "string") {
    return inViewDismissal === getCampaignKey(promotion);
  }
  if (
    inViewDismissal &&
    typeof inViewDismissal === "object" &&
    String(inViewDismissal.campaignKey || "").trim()
  ) {
    return String(inViewDismissal.campaignKey || "").trim() === getCampaignKey(promotion);
  }

  const dismissMode = promotion?.dismissBehavior?.mode || "none";
  const dismissKey = getDismissKey(promotion);

  if (dismissMode === "session") {
    return Boolean(stores.session?.dismissals?.[dismissKey]);
  }

  if (dismissMode === "days") {
    const record = stores.local?.dismissals?.[dismissKey];
    if (!record) return false;
    return Number(record.expiresAt || 0) > now;
  }

  if (dismissMode === "campaign") {
    const record = stores.local?.dismissals?.[dismissKey];
    if (!record) return false;
    return String(record.campaignKey || "").trim() === getCampaignKey(promotion);
  }

  return false;
};

export const isPromotionFrequencyCapped = (
  promotion = {},
  actorKey = "",
  stores = {},
  now = Date.now(),
) => {
  const frequencyCap = promotion?.frequencyCap || {};
  if (!getPromotionId(promotion) || frequencyCap?.mode === "none") return false;

  const storageType = getFrequencyStoreType(promotion);
  const store = storageType === "session" ? stores.session : stores.local;
  const timestamps = normalizeTimestamps(
    store?.impressions?.[getFrequencyKey(promotion, actorKey)],
    resolveFrequencyWindowMs(promotion),
    now,
  );

  return timestamps.length >= Math.max(Number(frequencyCap?.maxImpressions || 1), 1);
};
